import React from 'react';

/**
 * Shimmering placeholder grid for the loading state. Matches the shape of
 * the real grid so the UI doesn't "jump" when data arrives. Pure CSS,
 * no external deps.
 */
export function HeatmapLoadingSkeleton() {
  const rows = 6;
  const cols = 6;
  return (
    <div
      className="bg-bg-elevated rounded-lg border border-border-base p-4"
      data-testid="heatmap-skeleton"
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading engagement heatmap"
    >
      <div className="flex items-center gap-2 mb-3">
        <div className="h-4 w-4 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin" />
        <span className="text-xs text-fg-muted">
          Loading engagement heatmap…
        </span>
      </div>
      <div className="overflow-hidden">
        <div className="grid gap-1" style={{ gridTemplateColumns: `120px repeat(${cols}, 80px)` }}>
          <div className="h-6 bg-bg-raised/40 rounded animate-pulse" />
          {Array.from({ length: cols }).map((_, i) => (
            <div key={`h-${i}`} className="h-6 bg-bg-raised/40 rounded animate-pulse" />
          ))}
          {Array.from({ length: rows * (cols + 1) }).map((_, i) => (
            <div
              key={`c-${i}`}
              className="h-10 bg-bg-raised/30 rounded animate-pulse"
              style={{ animationDelay: `${(i % 7) * 70}ms` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
